import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Column, CustomModal, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../AppPromo.utils';
import AppStoreBadge from './app-store-badge.svg';
import appStoreQrUrl from './app-store-qr.png';
import styles from './AppPromoModal.module.scss';
import GooglePlayBadge from './google-play-badge.svg';
import googlePlayQrUrl from './google-play-qr.png';
export const GetAppPromoModalTID = (parentTestId)=>getTestIds(parentTestId);
export const AppPromoModal = (param)=>{
    let { dismissModal } = param;
    const { t: modalTexts } = useLocaleKeys('navigation.mobileAppPromo');
    const { browser } = useIoContext();
    const { AppPromoModalTID } = useMemo(()=>GetAppPromoModalTID(), []);
    return /*#__PURE__*/ _jsx(CustomModal, {
        testId: AppPromoModalTID.Root(),
        bi: {
            closeButton: {
                name: 'mobile_app_promo_modal_close'
            }
        },
        width: 600,
        onClose: dismissModal,
        className: styles.modal,
        headerClassName: styles.header,
        header: /*#__PURE__*/ _jsx(Typography, {
            variant: "h5",
            weight: "normal",
            testId: AppPromoModalTID.Title(),
            children: modalTexts.title()
        }),
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 24,
            className: styles.body,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph1",
                    children: modalTexts.body()
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    gap: 16,
                    className: styles.storeTiles,
                    children: [
                        /*#__PURE__*/ _jsxs(Column, {
                            gap: 16,
                            alignItems: "center",
                            className: styles.storeTile,
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: styles.qrCode,
                                    src: appStoreQrUrl,
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    className: styles.storeBadge,
                                    testId: AppPromoModalTID.AppStoreBadge(),
                                    bi: {
                                        name: 'mobile_app_promo_modal_appstore_badge'
                                    },
                                    onClick: ()=>browser.openNewTab(APP_STORE_URL),
                                    "aria-label": modalTexts.appStoreBadge(),
                                    children: /*#__PURE__*/ _jsx(AppStoreBadge, {
                                        className: styles.appStoreBadgeImg
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Column, {
                            gap: 16,
                            alignItems: "center",
                            className: styles.storeTile,
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: styles.qrCode,
                                    src: googlePlayQrUrl,
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    className: styles.storeBadge,
                                    testId: AppPromoModalTID.GooglePlayBadge(),
                                    bi: {
                                        name: 'mobile_app_promo_modal_googleplay_badge'
                                    },
                                    onClick: ()=>browser.openNewTab(GOOGLE_PLAY_URL),
                                    "aria-label": modalTexts.googlePlayBadge(),
                                    children: /*#__PURE__*/ _jsx(GooglePlayBadge, {
                                        className: styles.googlePlayBadgeImg
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
